import { render, staticRenderFns } from "./createClass.vue?vue&type=template&id=3184dbea&scoped=true"
import script from "./createClass.vue?vue&type=script&lang=js"
export * from "./createClass.vue?vue&type=script&lang=js"
import style0 from "./createClass.vue?vue&type=style&index=0&id=3184dbea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3184dbea",
  null
  
)

export default component.exports